import React, { Component } from 'react';
import { Table } from 'antd';
import _ from 'lodash';

import DividedBar from '../DividedBar/DividedBar';
import RankChangeIndicator from '../RankChangeIndicator/RankChangeIndicator';
import './RankingTable.scss';

import ProPic1 from './propic-1.png';
import ProPic2 from './propic-2.png';
import ProPic3 from './propic-3.png';
import ProPic4 from './propic-4.png';
import ProPic5 from './propic-5.png';
import ProPic6 from './propic-6.png';
import ProPic7 from './propic-7.png';
import ProPic8 from './propic-8.png';
import ProPic9 from './propic-9.png';
import ProPic10A from './propic-10a.png';

import script from './translations.js';
import OrgRankingApi from "../../apiClient/api/OrgRankingApi";

export class RankingTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataset: [
            //     {
            //     id: 1,
            //     class: '4D',
            //     rank: 1,
            //     question_points: 50,
            //     currency_balance: 100,
            //     rank_change: 1
            // }, {
            //     id: 2,
            //     class: '5D',
            //     rank: 2,
            //     question_points: 40,
            //     currency_balance: 90,
            //     rank_change: -1
            // }, {
            //     id: 3,
            //     class: '3D',
            //     rank: 3,
            //     question_points: 50,
            //     currency_balance: 20,
            //     rank_change: 0
            // }, {
            //     id: 4,
            //     class: '2D',
            //     rank: 4,
            //     question_points: 10,
            //     currency_balance: 10,
            //     rank_change: 0
            // }
            ]
        }
    }

    componentDidMount(){
        this.loadRanking();
    }

    loadRanking() {
        new OrgRankingApi().orgRanking(window.schoolId).then((data) => {
            console.log(data);
            let newData = _.sortBy(data.ranking["new"], (o) => {
                return o.balance
            }).reverse();

            let oldData =  _.sortBy(data.ranking["old"], (o) => {
                return o.balance
            }).reverse();

            let dataset = [];
            newData.forEach((v, i)=>{
                let oldIdx = _.findIndex(oldData, function(o) { return o.user.id == v.user.id });

                dataset.push({
                    id: v.user.id,
                    class: v.user.name,
                    rank: i+1,
                    question_points: v.answeredMcEarnedSum,
                    currency_balance: v.balance,
                    rank_change: oldIdx - i
                })
            });

            this.setState({ dataset: dataset});
        })
    }

    propicSelector(score) {
        const scoreLevel = Math.max(score - 100, 0);
        
        if (scoreLevel < 10) {
            return ProPic1;
        } else if (scoreLevel < 20) {
            return ProPic2;
        } else if (scoreLevel < 30) {
            return ProPic3;
        } else if (scoreLevel < 40) {
            return ProPic4;
        } else if (scoreLevel < 50) {
            return ProPic5;
        } else if (scoreLevel < 60) {
            return ProPic6;
        } else if (scoreLevel < 70) {
            return ProPic7;
        } else if (scoreLevel < 80) {
            return ProPic8;
        } else if (scoreLevel < 90) {
            return ProPic9;
        } else {
            return ProPic10A;
        }
    }

    render() {
        const { langCode, height } = this.props;
        const { dataset } = this.state;
        const maxTotalPts = _.max(_.map(dataset, (d) => d.currency_balance));
        const columns = [{
            title: script[langCode].classLabel,
            dataIndex: 'class',
            width: 150,
            align: 'center',
            render: (text, record) => (
                <div className="class-profile">
                    <img className="propic" src={this.propicSelector(record.currency_balance)} alt=""/>
                    <p>{text}</p>
                </div>
            )
        }, {
            title: script[langCode].rank,
            dataIndex: 'rank',
            width: 80,
            align: 'center'
        }, {
            title: () => (<p><span className="green-label"></span>{script[langCode].question} & <span className="red-label"></span>{script[langCode].currencyBalance}</p>),
            dataIndex: 'address',
            render: (text, record) => (
                <DividedBar
                    questionLabel={script[langCode].question}
                    questionPts={record.question_points}
                    currencyBalanceLabel={script[langCode].currencyBalance}
                    currencyBalancePts={record.currency_balance}
                    maxTotalPts={maxTotalPts}
                />
            )
        }, {
            title: script[langCode].totalPoints,
            dataIndex: 'total_points',
            width: 100,
            align: 'center',
            render: (text, record) => record.currency_balance || 0
        }, {
            title: script[langCode].rankChange,
            dataIndex: 'rank_change',
            width: 110,
            align: 'center',
            render: (text, record) => (<RankChangeIndicator rankChange={text} />)
        }];

        return (
            <Table
                className="RankingTable"
                rowKey="id"
                columns={columns}
                dataSource={dataset}
                pagination={false}
                scroll={{ y: height }}
            />
        );
    }
}

RankingTable.defaultProps = {
    langCode: 'en'
}

export default RankingTable;